module.exports = __webpack_public_path__ + "static/media/activos.737c2246.png";